
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("cw5oc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "DropzoneBase", () => $54b8ad6cb9714a16$export$5a0463c86df2b04c);
$parcel$export(module.exports, "default", () => $54b8ad6cb9714a16$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Dropzone", () => $54b8ad6cb9714a16$export$47d4850b9fdf5af1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");

var $lMILl = parcelRequire("lMILl");

var $h7y6A = parcelRequire("h7y6A");

var $lSaNN = parcelRequire("lSaNN");

var $asGq3 = parcelRequire("asGq3");
function $54b8ad6cb9714a16$var$dragContainsFiles(event) {
    if (!event.dataTransfer) return false;
    const { types: types } = event.dataTransfer;
    return Array.from(types).indexOf('Files') > -1;
}
const $54b8ad6cb9714a16$var$COMPONENT_NAME = 'dropzone';
class $54b8ad6cb9714a16$export$5a0463c86df2b04c extends (0, $h7y6A.LocalUploadComponentReact) {
    constructor(props){
        super(props, $54b8ad6cb9714a16$var$COMPONENT_NAME), this.uiActive = false, this.addContainerListeners = (container)=>{
            const target = container ?? this.getContainer();
            // TODO: migrate this file to Pragmatic drag and drop
            /* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ target.addEventListener('dragover', this.onDragOver, false);
            target.addEventListener('dragleave', this.onDragLeave, false);
            target.addEventListener('drop', this.onFileDropped);
        /* eslint-enable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ }, this.removeContainerListeners = (container)=>{
            const target = container ?? this.getContainer();
            target.removeEventListener('dragover', this.onDragOver, false);
            target.removeEventListener('dragleave', this.onDragLeave, false);
            target.removeEventListener('drop', this.onFileDropped);
        }, this.onDragOver = (event)=>{
            event.preventDefault();
            if (event.dataTransfer && $54b8ad6cb9714a16$var$dragContainsFiles(event)) {
                const dataTransfer = event.dataTransfer;
                let allowed;
                try {
                    allowed = dataTransfer.effectAllowed;
                } catch (e) {} // the error is expected in IE11
                dataTransfer.dropEffect = 'move' === allowed || 'linkMove' === allowed ? 'move' : 'copy';
                const length = this.getDraggedItemsLength(dataTransfer);
                // [EDM-1636]: needed in order to make multiple dropzones in the page to work
                event.stopPropagation();
                this.emitDragOver({
                    length: length
                });
            }
        }, this.onDragLeave = (e)=>{
            if (e.dataTransfer) {
                e.preventDefault();
                let length = 0;
                if ($54b8ad6cb9714a16$var$dragContainsFiles(e)) {
                    const dataTransfer = e.dataTransfer;
                    length = this.getDraggedItemsLength(dataTransfer);
                }
                this.emitDragLeave({
                    length: length
                });
            }
        }, this.onFileDropped = async (dragEvent)=>{
            if (!dragEvent.dataTransfer) return;
            dragEvent.preventDefault();
            dragEvent.stopPropagation();
            // refreshes uploadParams as only set once in parent constructor
            this.setUploadParams(this.props.config.uploadParams);
            this.onDrop(dragEvent);
            const files = Array.from(dragEvent.dataTransfer.files);
            this.uploadService.addFiles(files);
        }, this.onDrop = (e)=>{
            if (e.dataTransfer && $54b8ad6cb9714a16$var$dragContainsFiles(e)) {
                const dataTransfer = e.dataTransfer;
                const fileCount = this.getDraggedItemsLength(dataTransfer);
                this.sendAnalyticsAndEmitDragLeave(fileCount);
            }
        }, this.sendAnalyticsAndEmitDragLeave = (fileCount)=>{
            this.fireAnalyticsEvent('droppedInto', fileCount);
            if (this.props.onDrop) this.props.onDrop();
            this.emitDragLeave({
                length: fileCount
            });
        };
    }
    getContainer() {
        const { config: { container: container } } = this.props;
        return container || document.body;
    }
    componentDidMount() {
        const { onCancelFn: onCancelFn } = this.props;
        this.addContainerListeners(this.getContainer());
        if (onCancelFn) onCancelFn(this.cancel);
    }
    componentWillUnmount() {
        this.removeContainerListeners(this.getContainer());
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { config: { container: newContainer } } = nextProps;
        const { config: { container: oldContainer } } = this.props;
        if (newContainer !== oldContainer) {
            this.removeContainerListeners(oldContainer);
            this.addContainerListeners(newContainer);
        }
    }
    // Cross-browser way of getting dragged items length, we prioritize "items" if present
    // https://www.w3.org/TR/html51/editing.html#the-datatransfer-interface
    // This method is used on 'dragover' and we have no way to retrieve FileSystemFileEntry,
    // which contains info about if the dropped item is a file or directory. That info is only
    // available on 'drop'
    getDraggedItemsLength(dataTransfer) {
        if (dataTransfer.items) {
            const items = Array.from(dataTransfer.items);
            return items.filter((i)=>i.kind === 'file').length;
        }
        // This is required for IE11
        return dataTransfer.files.length;
    }
    emitDragOver(payload) {
        if (!this.uiActive) {
            const { onDragEnter: onDragEnter } = this.props;
            this.uiActive = true;
            this.fireAnalyticsEvent('draggedInto', payload.length);
            if (onDragEnter) onDragEnter(payload);
        }
    }
    emitDragLeave(payload) {
        if (this.uiActive) {
            this.uiActive = false;
            /*
       when drag over child elements, container will issue dragleave and then dragover immediately.
       The 50ms timeout will prevent from issuing that "false" dragleave event
       */ window.setTimeout(()=>{
                if (!this.uiActive) {
                    const { onDragLeave: onDragLeave } = this.props;
                    this.fireAnalyticsEvent('draggedOut', payload.length);
                    if (onDragLeave) onDragLeave(payload);
                }
            }, 50);
        }
    }
    fireAnalyticsEvent(action, fileCount) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const payload = {
                eventType: 'ui',
                actionSubject: 'dropzone',
                action: action,
                attributes: {
                    fileCount: fileCount
                }
            };
            const analyticsEvent = createAnalyticsEvent(payload);
            analyticsEvent.fire((0, $6409754536c5152d$export$ec1779cb96554e1));
        }
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $asGq3.default), {
            flagData: this.state.errorFlags,
            onFlagDismissed: this.dismissErrorFlag
        });
    }
}
var $54b8ad6cb9714a16$export$2e2bcd8739ae039 = $54b8ad6cb9714a16$export$5a0463c86df2b04c;
const $54b8ad6cb9714a16$export$47d4850b9fdf5af1 = (0, $lMILl.withMediaAnalyticsContext)((0, $lSaNN.getPackageAttributes)($54b8ad6cb9714a16$var$COMPONENT_NAME))((0, $cb25w.default)()($54b8ad6cb9714a16$export$5a0463c86df2b04c));

});
const $6409754536c5152d$export$ec1779cb96554e1 = 'media';

parcelRegister("lMILl", function(module, exports) {

$parcel$export(module.exports, "withMediaAnalyticsContext", () => $2f883e77faff2ecd$export$ba0fb5f6ba6ce56c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

const $2f883e77faff2ecd$export$ba0fb5f6ba6ce56c = (contextPublicAttributes)=>(WrappedComponent)=>{
        // forwardRef() allows passing React refs to the wrapped component WithMediaAnalyticsContext
        const WithMediaAnalyticsContext = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
            const { featureFlags: featureFlags } = props;
            const contextData = (0, $5uXOq.useMemo)(()=>{
                const contextPrivateAttributes = {
                    featureFlags: featureFlags
                };
                return {
                    ...contextPublicAttributes,
                    [(0, $b276966247f2f12d$export$70df29c238ba7306)]: {
                        ...contextPrivateAttributes
                    }
                };
            }, [
                featureFlags
            ]);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
                data: contextData,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                    ...props,
                    ref: ref
                })
            });
        });
        WithMediaAnalyticsContext.displayName = `WithMediaAnalyticsContext(${// @ts-ignore displayName doesn't exist on type
        WrappedComponent.displayName || WrappedComponent.name})`;
        return WithMediaAnalyticsContext;
    };

});
// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $b276966247f2f12d$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx


parcelRegister("h7y6A", function(module, exports) {

$parcel$export(module.exports, "LocalUploadComponentReact", () => $ca623a5767c33e9a$export$b7469e2ea01fbbd1);

var $5uXOq = parcelRequire("5uXOq");

var $dSxHR = parcelRequire("dSxHR");

var $loYHr = parcelRequire("loYHr");


var $bB6KS = parcelRequire("bB6KS");

var $dnmZI = parcelRequire("dnmZI");

var $lSaNN = parcelRequire("lSaNN");

var $9Gobd = parcelRequire("9Gobd");
class $ca623a5767c33e9a$export$b7469e2ea01fbbd1 extends (0, $5uXOq.Component) {
    constructor(props, componentName){
        super(props), this.componentName = componentName, this.uploadComponent = new (0, $bB6KS.UploadComponent)(), this.state = {
            errorFlags: []
        }, this.addErrorFlag = (flagData)=>{
            this.setState({
                errorFlags: [
                    ...this.state.errorFlags,
                    flagData
                ]
            });
        }, this.dismissErrorFlag = ()=>{
            this.setState({
                errorFlags: this.state.errorFlags.slice(1)
            });
        }, this.fireCommencedEvent = (payload)=>{
            const { files: files, traceContext: traceContext } = payload;
            files.forEach(({ id: fileId, size: fileSize, type: fileMimetype })=>{
                (0, $dSxHR.start)(`MediaPicker.fireUpload.${fileId}`);
                this.createAndFireAnalyticsEvent({
                    eventType: 'operational',
                    action: 'commenced',
                    actionSubject: 'mediaUpload',
                    actionSubjectId: 'localMedia',
                    attributes: {
                        sourceType: 'local',
                        serviceName: 'upload',
                        fileAttributes: {
                            fileId: fileId,
                            fileSize: fileSize,
                            fileMimetype: fileMimetype
                        },
                        traceContext: traceContext
                    }
                });
                (0, $9Gobd.startMediaUploadUfoExperience)(fileId, this.componentName);
            });
        }, this.fireUploadSucceeded = (payload)=>{
            const { file: { id: fileId, size: fileSize, type: fileMimetype }, traceContext: traceContext } = payload;
            const { duration: uploadDurationMsec = -1 } = (0, $dSxHR.end)(`MediaPicker.fireUpload.${fileId}`);
            this.createAndFireAnalyticsEvent({
                eventType: 'operational',
                action: 'succeeded',
                actionSubject: 'mediaUpload',
                actionSubjectId: 'localMedia',
                attributes: {
                    sourceType: 'local',
                    serviceName: 'upload',
                    status: 'success',
                    fileAttributes: {
                        fileId: fileId,
                        fileSize: fileSize,
                        fileMimetype: fileMimetype
                    },
                    uploadDurationMsec: uploadDurationMsec,
                    traceContext: traceContext
                }
            });
            (0, $9Gobd.succeedMediaUploadUfoExperience)(fileId, {
                fileId: fileId,
                fileSize: fileSize,
                fileMimetype: fileMimetype
            });
        }, this.fireUploadFailed = async (payload)=>{
            const { fileId: fileId, error: { name: errorName, rawError: rawError }, traceContext: traceContext } = payload;
            const { duration: uploadDurationMsec = -1 } = (0, $dSxHR.end)(`MediaPicker.fireUpload.${fileId}`);
            this.createAndFireAnalyticsEvent({
                eventType: 'operational',
                action: 'failed',
                actionSubject: 'mediaUpload',
                actionSubjectId: 'localMedia',
                attributes: {
                    sourceType: 'local',
                    serviceName: 'upload',
                    status: 'fail',
                    failReason: errorName,
                    error: !!rawError ? (0, $loYHr.getMediaClientErrorReason)(rawError) : 'unknown',
                    request: !!rawError ? (0, $lSaNN.getRequestMetadata)(rawError) : undefined,
                    fileAttributes: {
                        fileId: fileId
                    },
                    uploadDurationMsec: uploadDurationMsec,
                    traceContext: traceContext
                }
            });
            (0, $9Gobd.failMediaUploadUfoExperience)(fileId, {
                failReason: errorName,
                error: !!rawError ? (0, $loYHr.getMediaClientErrorReason)(rawError) : 'unknown',
                request: !!rawError ? (0, $lSaNN.getRequestMetadata)(rawError) : undefined,
                fileAttributes: {
                    fileId: fileId
                },
                uploadDurationMsec: uploadDurationMsec
            });
        }, this.createAndFireAnalyticsEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $6409754536c5152d$export$ec1779cb96554e1));
        }, this.cancel = (uniqueIdentifier)=>{
            this.uploadService.cancel(uniqueIdentifier);
        }, this.onFilesAdded = ({ files: files, traceContext: traceContext })=>{
            this.uploadComponent.emitUploadsStart(files, traceContext);
        }, this.onFilePreviewUpdate = ({ file: file, preview: preview })=>{
            this.uploadComponent.emitUploadPreviewUpdate(file, preview);
        }, this.onFileConverting = ({ file: file, traceContext: traceContext })=>{
            this.uploadComponent.emitUploadEnd(file, traceContext);
        }, this.onUploadError = ({ fileId: fileId, error: error, traceContext: traceContext })=>{
            this.uploadComponent.emitUploadError(fileId, error, traceContext);
        };
        const { mediaClient: mediaClient, config: config, onUploadsStart: onUploadsStart, onPreviewUpdate: onPreviewUpdate, onEnd: onEnd, onError: onError } = this.props;
        const tenantUploadParams = config.uploadParams;
        const { shouldCopyFileToRecents: shouldCopyFileToRecents = true } = config;
        this.uploadComponent.on('uploads-start', this.fireCommencedEvent);
        this.uploadComponent.on('upload-end', this.fireUploadSucceeded);
        this.uploadComponent.on('upload-error', this.fireUploadFailed);
        if (onUploadsStart) this.uploadComponent.on('uploads-start', onUploadsStart);
        if (onPreviewUpdate) this.uploadComponent.on('upload-preview-update', onPreviewUpdate);
        if (onEnd) this.uploadComponent.on('upload-end', onEnd);
        if (onError) this.uploadComponent.on('upload-error', onError);
        this.uploadService = new (0, $dnmZI.UploadServiceImpl)(mediaClient, tenantUploadParams, shouldCopyFileToRecents);
        this.uploadService.on('files-added', this.onFilesAdded);
        this.uploadService.on('file-preview-update', this.onFilePreviewUpdate);
        this.uploadService.on('file-converting', this.onFileConverting);
        this.uploadService.on('file-upload-error', this.onUploadError);
        const onFileRejection = (rejectionData)=>{
            const { onUploadRejection: onUploadRejection } = tenantUploadParams;
            const shouldOverride = onUploadRejection?.(rejectionData);
            if (!shouldOverride) this.addErrorFlag(rejectionData);
        };
        this.uploadService.onFileRejection(onFileRejection);
        this.uploadService.onFileEmpty(onFileRejection);
    }
    setUploadParams(uploadParams) {
        this.uploadService.setUploadParams(uploadParams);
    }
}

});
parcelRegister("dSxHR", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
(function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    /**
     * Boolean with the result of the check if package
     * is running on the browser or in a NodeJS environment
     *
     * @returns boolean
     *
     */ var isNodeJSEnv = Object.prototype.toString.call(typeof $6cAn5 !== 'undefined' ? $6cAn5 : 0) === '[object process]';
    /**
     * Boolean with the result of the check if User Timing API
     * is supported for the current browser/NodeJS version
     *
     * @returns boolean
     *
     */ var isUserTimingAPISupported = typeof performance !== 'undefined' && typeof performance.now !== 'undefined' && typeof performance.mark === 'function' && typeof performance.measure === 'function' && (typeof performance.clearMarks === 'function' || typeof performance.clearMeasures === 'function');
    /**
     * Boolean with the result of the check if PerformanceObservable
     * is supported for the current browser/NodeJS version
     *
     * @returns boolean
     *
     */ var isPerformanceObservableSupported = typeof PerformanceObserver !== 'undefined' && // eslint-disable-next-line compat/compat
    typeof PerformanceObserver.prototype !== 'undefined' && // eslint-disable-next-line compat/compat
    typeof PerformanceObserver.prototype.constructor === 'function';
    // Map() is not used in order to decrease the bundle
    var marksMap = {};
    var marksObserver = {};
    /**
     * Get the current time based on User Timing API or Date
     *
     * @returns number
     *
     */ var getTimeNow = function() {
        return isUserTimingAPISupported ? performance.now() : Date.now();
    };
    /**
     * Clear marks and measure of performance event
     *
     * @param markName - Performance marker to be checked
     *
     * @returns void
     *
     */ var clear = function(markName) {
        marksMap[markName] = undefined;
        // Removes PerformanceObserver references from memory
        if (!!marksObserver[markName]) marksObserver[markName] = undefined;
        if (!isUserTimingAPISupported) return;
        // Some versions of NodeJS doesn't support this method
        if (!isNodeJSEnv) performance.clearMeasures(markName);
        performance.clearMarks(markName);
    };
    /**
     * Start performance measure of event
     *
     * @param markName - Performance marker to be started
     *
     * @returns number
     *
     */ var start = function(markName) {
        if (isUserTimingAPISupported) {
            if (isNodeJSEnv && isPerformanceObservableSupported) {
                // eslint-disable-next-line compat/compat
                var obs_1 = new PerformanceObserver(function(list) {
                    marksObserver[markName] = list.getEntries().find(function(f) {
                        return f.name === markName;
                    });
                    obs_1.disconnect();
                });
                obs_1.observe({
                    entryTypes: [
                        'measure'
                    ]
                });
            }
            performance.mark(markName);
        }
        marksMap[markName] = getTimeNow();
    };
    /**
     * Finishes performance measure of event and
     * clear marks and measure if applicable
     *
     * @param markName - Performance marker to be checked
     * @param markNameToCompare - Optional mark to compare to
     *
     * @returns PerfMarksPerformanceEntry
     *
     */ var end = function(markName, markNameToCompare) {
        try {
            var startTime = marksMap[markName];
            if (!isUserTimingAPISupported) return startTime ? {
                duration: getTimeNow() - startTime,
                startTime: startTime,
                entryType: 'measure',
                name: markName
            } : {};
            // If there's no User Timing mark to be compared with,
            // the package will create one to be used for better comparison
            if (!markNameToCompare) performance.mark(markName + "-end");
            performance.measure(markName, markName, markNameToCompare || markName + "-end");
            if (isNodeJSEnv) {
                if (!!marksObserver[markName]) return marksObserver[markName];
                return startTime ? {
                    duration: getTimeNow() - startTime,
                    startTime: startTime,
                    entryType: 'measure',
                    name: markName
                } : {};
            }
            var entry = performance.getEntriesByName(markName).pop();
            return entry || {};
        } catch (e) {
            // If previous mark was missing for some reason, this will throw.
            // This could only happen if something in event loop crashed
            // in an unexpected place earlier.
            // Don't pile on with more errors.
            return {};
        } finally{
            // Clear marks immediately to avoid growing buffer.
            clear(markName);
            // Clear marks used for comparison in case of it's value was passed
            // If the mark to compare is not passed, it should remove the one we create with `-end` suffix
            clear(markNameToCompare || markName + "-end");
        }
    };
    /**
     * Clear all marks and measures of performance event
     *
     * @returns void
     *
     */ var clearAll = function() {
        marksMap = {};
        marksObserver = {};
        if (!isUserTimingAPISupported) return;
        // Some versions of NodeJS doesn't support this method
        if (!isNodeJSEnv) performance.clearMeasures();
        performance.clearMarks();
    };
    /**
     * Gets the result for all marks that matches with the given mark name
     *
     * @param markName - Performance marker to be checked
     *
     * @returns PerfMarksPerformanceNavigationTiming[]
     *
     */ var getEntriesByType = function(entryName) {
        // NodeJS doesn't have support for getEntriesByType
        if (!isUserTimingAPISupported || isNodeJSEnv) return [];
        return performance.getEntriesByType(entryName) || [];
    };
    /**
     * Gets the marks for `navigation` loaded mark
     *
     * @returns PerfMarksPerformanceNavigationTiming[]
     *
     */ var getNavigationMarker = function() {
        return getEntriesByType('navigation').pop() || {};
    };
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    /**
     * profiler using User Timing Api method.
     * It will return a `PerfMarksPerformanceEntry` or
     * an PerfMarksPerformanceEntry inside `mark` key + the content for the callback method
     * If the given callback returns something
     *
     * usage:
     *
     * perfMarksProfile(
     *   () => { /** method content *\/}
     *   'name of the mark for this method',
     *   );
     *
     * @param {(() => any | Promise<any>)} callback
     * @param {string} name
     * @returns {Promise<PerfMarksPerformanceEntry>}
     */ var profiler = function(callback, name) {
        return __awaiter(void 0, void 0, void 0, function() {
            var data, mark, error_1;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Starting the marks
                        start(name);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            callback()
                        ];
                    case 2:
                        data = _a.sent();
                        mark = end(name);
                        // Passing data as an object
                        return [
                            2 /*return*/ ,
                            !!data ? Object.assign({}, {
                                data: data,
                                mark: mark
                            }) : {
                                mark: mark
                            }
                        ];
                    case 3:
                        error_1 = _a.sent();
                        end(name);
                        throw error_1;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    exports1.clear = clear;
    exports1.clearAll = clearAll;
    exports1.end = end;
    exports1.getEntriesByType = getEntriesByType;
    exports1.getNavigationMarker = getNavigationMarker;
    exports1.isNodeJSEnv = isNodeJSEnv;
    exports1.isPerformanceObservableSupported = isPerformanceObservableSupported;
    exports1.isUserTimingAPISupported = isUserTimingAPISupported;
    exports1.profiler = profiler;
    exports1.start = start;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("loYHr", function(module, exports) {

$parcel$export(module.exports, "getMediaClientErrorReason", () => $8608a1f56c9594c2$export$c15d72765ee2baa4);
function $8608a1f56c9594c2$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $8608a1f56c9594c2$export$c15d72765ee2baa4(err) {
    return $8608a1f56c9594c2$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}

});

parcelRegister("bB6KS", function(module, exports) {

$parcel$export(module.exports, "UploadComponent", () => $cb7e6dc8c3c1a469$export$4ab2ad4b4d3e37a1);

var $gCETL = parcelRequire("gCETL");
class $cb7e6dc8c3c1a469$export$4ab2ad4b4d3e37a1 extends (0, $gCETL.GenericEventEmitter) {
    emitPluginItemsInserted(selectedPluginItems) {
        const payload = selectedPluginItems.map((item)=>{
            return {
                pluginName: item.serviceName,
                pluginFile: {
                    id: item.id,
                    metadata: item.metadata
                }
            };
        });
        this.emit('plugin-items-inserted', payload);
    }
    emitUploadsStart(files, traceContext) {
        this.emit('uploads-start', {
            files: files,
            traceContext: traceContext
        });
    }
    emitUploadPreviewUpdate(file, preview) {
        this.emit('upload-preview-update', {
            file: file,
            preview: preview
        });
    }
    emitUploadEnd(file, traceContext) {
        this.emit('upload-end', {
            file: file,
            traceContext: traceContext
        });
    }
    emitUploadError(fileId, error, traceContext) {
        this.emit('upload-error', {
            fileId: fileId,
            error: error,
            traceContext: traceContext
        });
    }
}

});
parcelRegister("gCETL", function(module, exports) {

$parcel$export(module.exports, "GenericEventEmitter", () => $acdd79cbba132b90$export$b538d95162a51b88);

var $7n9mn = parcelRequire("7n9mn");
class $acdd79cbba132b90$export$b538d95162a51b88 {
    once(event, listener) {
        this.emitter.once(event, listener);
    }
    on(event, listener) {
        this.emitter.on(event, listener);
    }
    onAny(listener) {
        this.emitter.onAny(listener);
    }
    addListener(event, listener) {
        this.emitter.addListener(event, listener);
    }
    off(event, listener) {
        this.emitter.off(event, listener);
    }
    removeListener(event, handler) {
        this.emitter.removeListener(event, handler);
    }
    removeAllListeners(event) {
        // We want to explicitly call removeAllListeners without any argument if event is undefined, otherwise will EventEmitter fail
        if (event === undefined) this.emitter.removeAllListeners();
        else this.emitter.removeAllListeners(event);
    }
    emit(event, payload) {
        return this.emitter.emit(event, payload);
    }
    constructor(){
        this.emitter = new (0, $7n9mn.EventEmitter2)({
            wildcard: true
        });
    }
}

});


parcelRegister("dnmZI", function(module, exports) {

$parcel$export(module.exports, "UploadServiceImpl", () => $6eca63f520c7d1d5$export$be35ed9686ead209);

var $bXrHm = parcelRequire("bXrHm");

var $bfb59 = parcelRequire("bfb59");
var $1As4I = parcelRequire("1As4I");
var $1DpV0 = parcelRequire("1DpV0");

var $7E56q = parcelRequire("7E56q");

var $7n9mn = parcelRequire("7n9mn");

var $aoQVt = parcelRequire("aoQVt");

var $ioqnC = parcelRequire("ioqnC");

var $hxXNE = parcelRequire("hxXNE");

var $jzW7G = parcelRequire("jzW7G");
var $27T0s = parcelRequire("27T0s");
var $8GKRF = parcelRequire("8GKRF");
const $6eca63f520c7d1d5$var$generateTraceContext = ()=>({
        traceId: (0, $27T0s.getRandomHex)(8)
    });
class $6eca63f520c7d1d5$export$be35ed9686ead209 {
    constructor(tenantMediaClient, tenantUploadParams, shouldCopyFileToRecents, maxUploadBatchSize = 255){
        this.tenantMediaClient = tenantMediaClient;
        this.tenantUploadParams = tenantUploadParams;
        this.shouldCopyFileToRecents = shouldCopyFileToRecents;
        this.maxUploadBatchSize = maxUploadBatchSize;
        this.emit = (event, payload)=>{
            this.emitter.emit(event, payload);
        };
        this.onFileSuccess = async (cancellableFileUpload, fileId, traceContext)=>{
            const { mediaFile: mediaFile } = cancellableFileUpload;
            this.emit('file-converting', {
                file: mediaFile,
                traceContext: traceContext
            });
            cancellableFileUpload.cancel = ()=>{
                this.releaseCancellableFile(mediaFile);
            };
        };
        this.onFileError = (mediaFile, name, error, traceContext)=>{
            this.releaseCancellableFile(mediaFile);
            if (error === 'canceled') // Specific error coming from chunkinator via rejected fileId promise.
            // We do not want to trigger error in this case.
            return;
            const description = error instanceof Error ? error.message : error;
            const rawError = error instanceof Error ? error : undefined;
            this.emit('file-upload-error', {
                fileId: mediaFile.id,
                error: {
                    fileId: mediaFile.id,
                    name: name,
                    description: description,
                    rawError: rawError
                },
                traceContext: traceContext
            });
        };
        this.emitter = new (0, $7n9mn.EventEmitter2)();
        this.cancellableFilesUploads = {};
    }
    setUploadParams(uploadParams) {
        this.tenantUploadParams = uploadParams;
    }
    // Used for testing
    createUploadController() {
        return new (0, $1DpV0.UploadController)();
    }
    addFiles(files) {
        this.addFilesWithSource(files.map((file)=>({
                file: file,
                source: (0, $ioqnC.LocalFileSource).LocalUpload
            })));
    }
    addFile(file, replaceFileId) {
        this.addFilesWithSource([
            {
                file: file,
                source: (0, $ioqnC.LocalFileSource).LocalUpload,
                replaceFileId: replaceFileId
            }
        ]);
    }
    async addFilesWithSource(files, traceContext = $6eca63f520c7d1d5$var$generateTraceContext()) {
        const batches = [];
        for(let iterator = 0; iterator < files.length; iterator += this.maxUploadBatchSize)batches.push(this.addFilesAndUpload(files.slice(iterator, iterator + this.maxUploadBatchSize), traceContext));
        await Promise.all(batches);
    }
    isCancellableFileUpload(fileUpload) {
        return fileUpload !== null;
    }
    cancel(id) {
        if (id) {
            const cancellableFileUpload = this.cancellableFilesUploads[id];
            if (cancellableFileUpload && cancellableFileUpload.cancel) cancellableFileUpload.cancel();
        } else Object.keys(this.cancellableFilesUploads).forEach((key)=>{
            const cancellableFileUpload = this.cancellableFilesUploads[key];
            if (cancellableFileUpload.cancel) cancellableFileUpload.cancel();
        });
    }
    on(event, listener) {
        this.emitter.on(event, listener);
    }
    off(event, listener) {
        this.emitter.off(event, listener);
    }
    async addFilesAndUpload(files, traceContext) {
        if (files.length === 0) return;
        const creationDate = Date.now();
        const { userMediaClient: userMediaClient, tenantMediaClient: tenantMediaClient, shouldCopyFileToRecents: shouldCopyFileToRecents } = this;
        const mediaClient = shouldCopyFileToRecents ? tenantMediaClient : userMediaClient;
        const { collection: collectionTentant, expireAfter: expireAfter } = this.tenantUploadParams;
        const collection = shouldCopyFileToRecents ? collectionTentant : (0, $7E56q.RECENTS_COLLECTION);
        if (!mediaClient) return;
        const touchFileDescriptors = [];
        for(let i = 0; i < files.length; i++){
            const { replaceFileId: replaceFileId, file: file } = files[i];
            touchFileDescriptors.push({
                fileId: replaceFileId || (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))(),
                occurrenceKey: (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))(),
                collection: collection,
                size: file.size,
                expireAfter: expireAfter
            });
        }
        let touchedFiles;
        let caughtError;
        try {
            touchedFiles = await mediaClient.file.touchFiles(touchFileDescriptors, collection, traceContext);
        } catch (error) {
            caughtError = error;
        }
        const cancellableFileUploads = files.map(({ file: file, source: source }, i)=>{
            const { fileId: id, occurrenceKey: occurrenceKey } = touchFileDescriptors[i];
            // exclude rejected files from being uploaded
            const rejectedFile = touchedFiles?.rejected?.find(({ fileId: rejectedFileId })=>rejectedFileId === id);
            if (rejectedFile) {
                if (this.fileRejectionHandler) this.fileRejectionHandler({
                    reason: 'fileSizeLimitExceeded',
                    fileName: file.name,
                    limit: rejectedFile.error.limit
                });
                return null;
            }
            // exclude empty files from being uploaded
            if (file.size === 0) {
                if (this.fileEmptyHandler) this.fileEmptyHandler({
                    reason: 'fileEmpty',
                    fileName: file.name
                });
                return null;
            }
            const touchedFile = touchedFiles?.created.find((touchedFile)=>touchedFile.fileId === id);
            let deferredUploadId;
            const isIdConflictError = caughtError instanceof (0, $1As4I.RequestError) && caughtError.metadata?.statusCode === 409;
            if (touchedFile) deferredUploadId = Promise.resolve(touchedFile.uploadId);
            else if (isIdConflictError) // will occur when the backend receives a fileId that already exists in which case
            // we will create a single upload session for that file and use that uploadId
            deferredUploadId = mediaClient.mediaStore.createUpload(1, collection, traceContext).then((res)=>{
                return res.data[0].id;
            });
            else // in the case of unexpected errors, we want to defer the throwing of the error
            // until after the files-added has been emitted,
            // allows editor to show a broken media card for unexpected errors
            deferredUploadId = Promise.reject(caughtError);
            const uploadableFile = {
                collection: collection,
                content: file,
                name: file.name,
                mimeType: file.type,
                size: file.size
            };
            const uploadableUpfrontIds = {
                id: id,
                occurrenceKey: occurrenceKey,
                deferredUploadId: deferredUploadId
            };
            const controller = this.createUploadController();
            const sourceFileObservable = mediaClient.file.upload(uploadableFile, controller, uploadableUpfrontIds, traceContext);
            const mediaFile = {
                id: id,
                name: file.name,
                size: file.size,
                creationDate: creationDate,
                type: file.type,
                occurrenceKey: occurrenceKey
            };
            const cancellableFileUpload = {
                mediaFile: mediaFile,
                file: file,
                source: source,
                cancel: ()=>{
                    // we can't do "cancellableFileUpload.cancel = controller.abort" because will change the "this" mediaClient
                    controller.abort();
                }
            };
            const { unsubscribe: unsubscribe } = sourceFileObservable.subscribe({
                next: (state)=>{
                    if (state.status === 'processing' || state.status === 'processed' || state.status === 'failed-processing') {
                        unsubscribe();
                        if (shouldCopyFileToRecents) {
                            mediaClient.emit('file-added', state);
                            (0, $bfb59.globalMediaEventEmitter).emit('file-added', state);
                        }
                        this.onFileSuccess(cancellableFileUpload, id, traceContext);
                    }
                    if (state.status === 'error') this.onFileError(mediaFile, 'upload_fail', state.message || 'no-message', traceContext);
                },
                error: (error)=>{
                    this.onFileError(mediaFile, 'upload_fail', error, traceContext);
                }
            });
            this.cancellableFilesUploads[id] = cancellableFileUpload;
            return cancellableFileUpload;
        });
        const filteredCancellableFileUploads = cancellableFileUploads.filter(this.isCancellableFileUpload);
        const mediaFiles = filteredCancellableFileUploads.map((cancellableFileUpload)=>cancellableFileUpload.mediaFile);
        this.emit('files-added', {
            files: mediaFiles,
            traceContext: traceContext
        });
        this.emitPreviews(filteredCancellableFileUploads);
    }
    emitPreviews(cancellableFileUploads) {
        cancellableFileUploads.forEach((cancellableFileUpload)=>{
            const { file: file, mediaFile: mediaFile, source: source } = cancellableFileUpload;
            const { type: type } = file;
            const mediaType = this.getMediaTypeFromFile(file);
            if (!(0, $8GKRF.isMimeTypeSupportedByBrowser)(type)) {
                this.emit('file-preview-update', {
                    file: mediaFile,
                    preview: {}
                });
                return;
            }
            if (mediaType === 'image') (0, $aoQVt.getPreviewFromImage)(file, source === (0, $ioqnC.LocalFileSource).PastedScreenshot ? window.devicePixelRatio : undefined).then((preview)=>{
                this.emit('file-preview-update', {
                    file: mediaFile,
                    preview: preview
                });
            });
            else (0, $hxXNE.getPreviewFromBlob)(mediaType, file).then((preview)=>{
                this.emit('file-preview-update', {
                    file: mediaFile,
                    preview: preview
                });
            }).catch(()=>this.emit('file-preview-update', {
                    file: mediaFile,
                    preview: {}
                }));
        });
    }
    getMediaTypeFromFile(file) {
        const { type: type } = file;
        return (0, $jzW7G.getMediaTypeFromMimeType)(type);
    }
    releaseCancellableFile(mediaFile) {
        delete this.cancellableFilesUploads[mediaFile.id];
    }
    onFileEmpty(handler) {
        this.fileEmptyHandler = handler;
    }
    onFileRejection(handler) {
        this.fileRejectionHandler = handler;
    }
}

});
parcelRegister("bfb59", function(module, exports) {

$parcel$export(module.exports, "globalMediaEventEmitter", () => $22065e01bf236cb8$export$68d003d3105952ad);
parcelRequire("LmkUS");
var $6a8j4 = parcelRequire("6a8j4");
const $22065e01bf236cb8$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $6a8j4.mediaState).eventEmitter) (0, $6a8j4.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $6a8j4.mediaState).eventEmitter) (0, $6a8j4.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $6a8j4.mediaState).eventEmitter) return (0, $6a8j4.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});
parcelRegister("LmkUS", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => (parcelRequire("6a8j4")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("hQvj4")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("hQvj4")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("gPrGh")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $6a8j4 = parcelRequire("6a8j4");

var $hQvj4 = parcelRequire("hQvj4");

var $gPrGh = parcelRequire("gPrGh");

});
parcelRegister("6a8j4", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => $dc598dfdde7cc536$export$8cef61637918b288);

var $7n9mn = parcelRequire("7n9mn");

var $iwKVT = parcelRequire("iwKVT");
const $dc598dfdde7cc536$export$8cef61637918b288 = {
    streams: new (0, $iwKVT.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $7n9mn.EventEmitter2)()
};

});
parcelRegister("iwKVT", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("hQvj4", function(module, exports) {

$parcel$export(module.exports, "isClientBasedAuth", () => $449c85d7d5bc4f1f$export$6ba49fcac9c46e54);
$parcel$export(module.exports, "authToOwner", () => $449c85d7d5bc4f1f$export$17f6055767a8d96a);
function $449c85d7d5bc4f1f$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $449c85d7d5bc4f1f$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
const $449c85d7d5bc4f1f$export$17f6055767a8d96a = (auth)=>{
    if ($449c85d7d5bc4f1f$export$af1ab14f2246ef72(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});

parcelRegister("gPrGh", function(module, exports) {

$parcel$export(module.exports, "ChunkHashAlgorithm", () => $506f1dfda055692a$export$d3e73a50cc549c2e);
var $506f1dfda055692a$export$d3e73a50cc549c2e = /*#__PURE__*/ function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha1"] = "sha1";
    ChunkHashAlgorithm["Sha256"] = "sha256";
    return ChunkHashAlgorithm;
}({});

});



parcelRegister("1As4I", function(module, exports) {

$parcel$export(module.exports, "RequestError", () => $a9b96946563d0d09$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $a9b96946563d0d09$export$3717b1ffef4428ea);

var $gFZHi = parcelRequire("gFZHi");
class $a9b96946563d0d09$export$43ee7d0e4f429743 extends (0, $gFZHi.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode, traceContext: traceContext } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            metadata: {
                traceContext: traceContext
            },
            innerError: innerError
        };
    }
}
function $a9b96946563d0d09$export$3717b1ffef4428ea(err) {
    return err instanceof $a9b96946563d0d09$export$43ee7d0e4f429743;
}

});
parcelRegister("gFZHi", function(module, exports) {

$parcel$export(module.exports, "BaseMediaClientError", () => $fd6342ef86e499fe$export$2b0aca14d61c3190);
$parcel$export(module.exports, "CommonMediaClientError", () => $fd6342ef86e499fe$export$e574d1724215079f);
$parcel$export(module.exports, "isCommonMediaClientError", () => $fd6342ef86e499fe$export$881f0f9bc813e1f3);
$parcel$export(module.exports, "toCommonMediaClientError", () => $fd6342ef86e499fe$export$a5db89cfc88eff9);
$parcel$export(module.exports, "fromCommonMediaClientError", () => $fd6342ef86e499fe$export$c2b89b9a32286816);

var $loYHr = parcelRequire("loYHr");
class $fd6342ef86e499fe$export$2b0aca14d61c3190 extends Error {
    constructor(reason, metadata, innerError){
        super(reason), this.reason = reason, this.metadata = metadata, this.innerError = innerError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $fd6342ef86e499fe$export$e574d1724215079f extends $fd6342ef86e499fe$export$2b0aca14d61c3190 {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    get attributes() {
        return {
            reason: this.reason
        };
    }
}
function $fd6342ef86e499fe$export$881f0f9bc813e1f3(error) {
    if (!error) return false;
    // Check if the error is an instance of Error
    if (error instanceof $fd6342ef86e499fe$export$e574d1724215079f) return true;
    return typeof error.reason === 'string' && ('metadata' in error || error.metadata === undefined) && ('innerError' in error || error.innerError === undefined);
}
const $fd6342ef86e499fe$export$a5db89cfc88eff9 = (errorFileState)=>{
    const error = errorFileState.details?.error;
    return new $fd6342ef86e499fe$export$e574d1724215079f(error?.reason || 'unknown-reason', error.metadata, error.innerError);
};
const $fd6342ef86e499fe$export$c2b89b9a32286816 = (id, occurrenceKey, error)=>{
    return {
        status: 'error',
        id: id,
        occurrenceKey: occurrenceKey,
        reason: error.reason,
        details: {
            /** Use this attr to translate back into CommonMediaClientError (toCommonMediaClientError) */ error: {
                reason: error?.reason,
                metadata: error?.metadata,
                innerError: error?.innerError
            },
            // Legacy details
            ...error?.attributes
        },
        message: error?.message
    };
};

});


parcelRegister("1DpV0", function(module, exports) {

$parcel$export(module.exports, "UploadController", () => $b3bde65819609256$export$3672045780a315e3);
class $b3bde65819609256$export$3672045780a315e3 {
    constructor(){}
    setAbort(abortFunction) {
        this.abortFunction = abortFunction;
    }
    abort() {
        if (this.abortFunction) this.abortFunction();
    }
}

});

parcelRegister("7E56q", function(module, exports) {

$parcel$export(module.exports, "RECENTS_COLLECTION", () => $7a454a77a18dd963$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $7a454a77a18dd963$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $7a454a77a18dd963$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $7a454a77a18dd963$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $7a454a77a18dd963$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $7a454a77a18dd963$export$f14f521f3d306044);

var $749LC = parcelRequire("749LC");
const $7a454a77a18dd963$export$860a16125e30000b = 'recents';
const $7a454a77a18dd963$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $7a454a77a18dd963$export$6e70f30e392bc53f = 4096;
const $7a454a77a18dd963$export$c1abb8bab1e615cd = 5 * (0, $749LC.DATA_UNIT).MB;
const $7a454a77a18dd963$export$3d5157f0def70e54 = 1000;
const $7a454a77a18dd963$export$f14f521f3d306044 = 2 * (0, $749LC.DATA_UNIT).TB;

});
parcelRegister("749LC", function(module, exports) {

$parcel$export(module.exports, "isNotFoundMediaItemDetails", () => $330ebd66cbfb5bbe$export$fd27d7abbc4a746d);
$parcel$export(module.exports, "DATA_UNIT", () => $330ebd66cbfb5bbe$export$76cfea4c354af843);
const $330ebd66cbfb5bbe$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
const $330ebd66cbfb5bbe$export$fd27d7abbc4a746d = (itemDetails)=>{
    return 'type' in itemDetails && itemDetails.type === 'not-found';
};
var $330ebd66cbfb5bbe$export$76cfea4c354af843 = /*#__PURE__*/ function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    return DATA_UNIT;
}({});

});


parcelRegister("aoQVt", function(module, exports) {

$parcel$export(module.exports, "getPreviewFromImage", () => $811e52c815f92748$export$34f0dda2cf8fd624);

var $1xbJn = parcelRequire("1xbJn");
var $48aIR = parcelRequire("48aIR");
async function $811e52c815f92748$export$34f0dda2cf8fd624(file, devicePixelRatio) {
    const fileInfo = await (0, $1xbJn.getFileInfo)(file);
    const imageInfo = await (0, $48aIR.getImageInfo)(fileInfo);
    if (imageInfo === null) return {
        file: file
    };
    else {
        const { width: width, height: height, scaleFactor: scaleFactor } = imageInfo;
        const preview = {
            file: file,
            dimensions: {
                width: width,
                height: height
            },
            scaleFactor: devicePixelRatio || scaleFactor
        };
        return preview;
    }
}
const $811e52c815f92748$export$5993f94be79b482e = 1;

});
parcelRegister("1xbJn", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $3c9a3ebb8ee397f0$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $3c9a3ebb8ee397f0$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $3c9a3ebb8ee397f0$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $3c9a3ebb8ee397f0$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $3c9a3ebb8ee397f0$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $3c9a3ebb8ee397f0$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $3c9a3ebb8ee397f0$export$61a1de0822e2820);

var $2tm8x = parcelRequire("2tm8x");

var $RiK2l = parcelRequire("RiK2l");

var $cHwqN = parcelRequire("cHwqN");

var $2sfBf = parcelRequire("2sfBf");

var $iABw2 = parcelRequire("iABw2");

var $7hpMa = parcelRequire("7hpMa");

var $dGYEZ = parcelRequire("dGYEZ");

var $iBOon = parcelRequire("iBOon");

var $jdlqN = parcelRequire("jdlqN");

var $c70Lr = parcelRequire("c70Lr");

var $2osAJ = parcelRequire("2osAJ");

var $7zjHG = parcelRequire("7zjHG");

var $8SPcB = parcelRequire("8SPcB");

var $es8mD = parcelRequire("es8mD");

var $gYsK7 = parcelRequire("gYsK7");

var $8RqHP = parcelRequire("8RqHP");
function $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $3c9a3ebb8ee397f0$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $3c9a3ebb8ee397f0$export$849633012686f7ee(file)
    };
}
async function $3c9a3ebb8ee397f0$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $3c9a3ebb8ee397f0$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $3c9a3ebb8ee397f0$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $3c9a3ebb8ee397f0$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $3c9a3ebb8ee397f0$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $3c9a3ebb8ee397f0$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2tm8x)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdlqN)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2osAJ)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdlqN)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c70Lr)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iBOon)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2sfBf)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($es8mD)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHwqN)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($RiK2l)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8SPcB)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7zjHG)))
    }
];
function $3c9a3ebb8ee397f0$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $3c9a3ebb8ee397f0$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $8RqHP.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gYsK7)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iABw2)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7hpMa)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dGYEZ)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("2tm8x", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1ccf7616b127308b$var$_react = $1ccf7616b127308b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1ccf7616b127308b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ccf7616b127308b$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $1ccf7616b127308b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1ccf7616b127308b$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $1ccf7616b127308b$var$_default = module.exports.default = $1ccf7616b127308b$var$PdfDocument24Icon;

});

parcelRegister("RiK2l", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0a037d07967bfa4f$var$_react = $0a037d07967bfa4f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $0a037d07967bfa4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0a037d07967bfa4f$var$Gif24Icon = (props)=>/*#__PURE__*/ $0a037d07967bfa4f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$0a037d07967bfa4f$var$Gif24Icon.displayName = 'Gif24Icon';
var $0a037d07967bfa4f$var$_default = module.exports.default = $0a037d07967bfa4f$var$Gif24Icon;

});

parcelRegister("cHwqN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $93f2a85309224bbe$var$_react = $93f2a85309224bbe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $93f2a85309224bbe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $93f2a85309224bbe$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $93f2a85309224bbe$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$93f2a85309224bbe$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $93f2a85309224bbe$var$_default = module.exports.default = $93f2a85309224bbe$var$PowerpointPresentation24Icon;

});

parcelRegister("2sfBf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1c9a4c12d2fc4227$var$_react = $1c9a4c12d2fc4227$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1c9a4c12d2fc4227$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1c9a4c12d2fc4227$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $1c9a4c12d2fc4227$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1c9a4c12d2fc4227$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $1c9a4c12d2fc4227$var$_default = module.exports.default = $1c9a4c12d2fc4227$var$WordDocument24Icon;

});

parcelRegister("iABw2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d888b0a1557aa645$var$_react = $d888b0a1557aa645$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d888b0a1557aa645$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d888b0a1557aa645$var$Sketch24Icon = (props)=>/*#__PURE__*/ $d888b0a1557aa645$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d888b0a1557aa645$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $d888b0a1557aa645$var$_default = module.exports.default = $d888b0a1557aa645$var$Sketch24Icon;

});

parcelRegister("7hpMa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $54ce1d7bd56eb231$var$_react = $54ce1d7bd56eb231$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $54ce1d7bd56eb231$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $54ce1d7bd56eb231$var$Figma24Icon = (props)=>/*#__PURE__*/ $54ce1d7bd56eb231$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$54ce1d7bd56eb231$var$Figma24Icon.displayName = 'Figma24Icon';
var $54ce1d7bd56eb231$var$_default = module.exports.default = $54ce1d7bd56eb231$var$Figma24Icon;

});

parcelRegister("dGYEZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9f7e406d5bea49df$var$_react = $9f7e406d5bea49df$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9f7e406d5bea49df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9f7e406d5bea49df$var$Executable24Icon = (props)=>/*#__PURE__*/ $9f7e406d5bea49df$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9f7e406d5bea49df$var$Executable24Icon.displayName = 'Executable24Icon';
var $9f7e406d5bea49df$var$_default = module.exports.default = $9f7e406d5bea49df$var$Executable24Icon;

});

parcelRegister("iBOon", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d8c2c58dddf5fcc0$var$_react = $d8c2c58dddf5fcc0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d8c2c58dddf5fcc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d8c2c58dddf5fcc0$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $d8c2c58dddf5fcc0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d8c2c58dddf5fcc0$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $d8c2c58dddf5fcc0$var$_default = module.exports.default = $d8c2c58dddf5fcc0$var$GoogleDoc24Icon;

});

parcelRegister("jdlqN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $dfcfdb061c664b77$var$_react = $dfcfdb061c664b77$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $dfcfdb061c664b77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dfcfdb061c664b77$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $dfcfdb061c664b77$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$dfcfdb061c664b77$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $dfcfdb061c664b77$var$_default = module.exports.default = $dfcfdb061c664b77$var$GoogleForm24Icon;

});

parcelRegister("c70Lr", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $8d16bb363c31083e$var$_react = $8d16bb363c31083e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $8d16bb363c31083e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8d16bb363c31083e$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $8d16bb363c31083e$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$8d16bb363c31083e$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $8d16bb363c31083e$var$_default = module.exports.default = $8d16bb363c31083e$var$GoogleSheet24Icon;

});

parcelRegister("2osAJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1be4005185ae78d9$var$_react = $1be4005185ae78d9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1be4005185ae78d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1be4005185ae78d9$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $1be4005185ae78d9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1be4005185ae78d9$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $1be4005185ae78d9$var$_default = module.exports.default = $1be4005185ae78d9$var$GoogleSlide24Icon;

});

parcelRegister("7zjHG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $582b1603b710ea90$var$_react = $582b1603b710ea90$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $582b1603b710ea90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $582b1603b710ea90$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $582b1603b710ea90$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$582b1603b710ea90$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $582b1603b710ea90$var$_default = module.exports.default = $582b1603b710ea90$var$ExcelSpreadsheet24Icon;

});

parcelRegister("8SPcB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $677b15938c7d624c$var$_react = $677b15938c7d624c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $677b15938c7d624c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $677b15938c7d624c$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $677b15938c7d624c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$677b15938c7d624c$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $677b15938c7d624c$var$_default = module.exports.default = $677b15938c7d624c$var$Spreadsheet24Icon;

});

parcelRegister("es8mD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a85a2b23143ceb75$var$_react = $a85a2b23143ceb75$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $a85a2b23143ceb75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a85a2b23143ceb75$var$Presentation24Icon = (props)=>/*#__PURE__*/ $a85a2b23143ceb75$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$a85a2b23143ceb75$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $a85a2b23143ceb75$var$_default = module.exports.default = $a85a2b23143ceb75$var$Presentation24Icon;

});

parcelRegister("gYsK7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c5b88baa981b1084$var$_react = $c5b88baa981b1084$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $c5b88baa981b1084$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c5b88baa981b1084$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $c5b88baa981b1084$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c5b88baa981b1084$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $c5b88baa981b1084$var$_default = module.exports.default = $c5b88baa981b1084$var$SourceCode24Icon;

});

parcelRegister("8RqHP", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $60b93921782d6d1e$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $60b93921782d6d1e$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $60b93921782d6d1e$export$ba4368c844580f9e);
function $60b93921782d6d1e$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $60b93921782d6d1e$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $60b93921782d6d1e$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $60b93921782d6d1e$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $60b93921782d6d1e$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("48aIR", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $93f6c931eebc2be3$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $93f6c931eebc2be3$export$67689507e8404821);

var $k9Ch0 = parcelRequire("k9Ch0");

var $5m9mt = parcelRequire("5m9mt");

var $1xbJn = parcelRequire("1xbJn");

var $hNjKA = parcelRequire("hNjKA");
const { Orientation: $93f6c931eebc2be3$var$Orientation, XResolution: $93f6c931eebc2be3$var$XResolution } = (0, $k9Ch0.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $93f6c931eebc2be3$var$DPI_WEB_BASELINE = 72;
async function $93f6c931eebc2be3$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $93f6c931eebc2be3$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $93f6c931eebc2be3$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $93f6c931eebc2be3$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
        else return $93f6c931eebc2be3$export$268f92356524130b(tags, $93f6c931eebc2be3$var$XResolution, $93f6c931eebc2be3$var$DPI_WEB_BASELINE) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $93f6c931eebc2be3$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$93f6c931eebc2be3$var$Orientation]) {
        const tagValue = tags[$93f6c931eebc2be3$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $k9Ch0.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $93f6c931eebc2be3$export$67689507e8404821(file) {
    const tags = await (0, $5m9mt.readImageMetaTags)(file);
    return $93f6c931eebc2be3$var$getOrientationFromTags(tags);
}
function $93f6c931eebc2be3$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $93f6c931eebc2be3$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $5m9mt.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $1xbJn.loadImage)(src);
        const { width: width, height: height } = (0, $1xbJn.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("k9Ch0", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $8ba626f637ae3df3$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $8ba626f637ae3df3$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $8ba626f637ae3df3$export$f6ea0c89fd7d156);
var $8ba626f637ae3df3$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $8ba626f637ae3df3$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $8ba626f637ae3df3$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("5m9mt", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $6da5c9a89db4de84$export$41982b5c7acb23c4);

var $k9Ch0 = parcelRequire("k9Ch0");

var $jkveD = parcelRequire("jkveD");

var $kINoG = parcelRequire("kINoG");

var $2edT6 = parcelRequire("2edT6");
async function $6da5c9a89db4de84$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $k9Ch0.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $kINoG.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $2edT6.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $k9Ch0.ImageType).JPEG) return await (0, $jkveD.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("jkveD", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $537aa8dc852a8555$export$556b2ccec62d7f2a);

var $k9Ch0 = parcelRequire("k9Ch0");
const { XResolution: $537aa8dc852a8555$var$XResolution, YResolution: $537aa8dc852a8555$var$YResolution } = (0, $k9Ch0.SupportedImageMetaTag);
let $537aa8dc852a8555$var$loadImage;

function $537aa8dc852a8555$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$537aa8dc852a8555$var$loadImage) {
            const module = await (parcelRequire("8iz07"));
            $537aa8dc852a8555$var$loadImage = module.default || module;
        }
        $537aa8dc852a8555$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $537aa8dc852a8555$var$XResolution || key === $537aa8dc852a8555$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("8iz07", function(module, exports) {

let $60ab27a2818ad2da$var$load = (parcelRequire("28QjX"))(4);
module.exports = $60ab27a2818ad2da$var$load("7lJbN").then(()=>parcelRequire('8aLn9'));

});


parcelRegister("kINoG", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $013315ab2d0cc3cf$export$5fb37736440fca6f);

var $1xbJn = parcelRequire("1xbJn");
let $013315ab2d0cc3cf$var$pngChunksExtract;

async function $013315ab2d0cc3cf$export$5fb37736440fca6f(file) {
    if (!$013315ab2d0cc3cf$var$pngChunksExtract) {
        const module = await (parcelRequire("8u6C4"));
        $013315ab2d0cc3cf$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $1xbJn.fileToArrayBuffer)(file);
    const chunks = $013315ab2d0cc3cf$var$pngChunksExtract(buffer);
    return await $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks);
}
async function $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("8u6C4", function(module, exports) {

let $019819d3d04dcea8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $019819d3d04dcea8$var$load("jODAF").then(()=>parcelRequire('eYIux'));

});


parcelRegister("2edT6", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $1cac606283e05089$export$55c3bc9841b19de2);
function $1cac606283e05089$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("hNjKA", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $81d3fceca65be0fc$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $81d3fceca65be0fc$export$43142f95b8de7a91);
const $81d3fceca65be0fc$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $81d3fceca65be0fc$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $81d3fceca65be0fc$export$43142f95b8de7a91 = (orientation)=>{
    return $81d3fceca65be0fc$var$ORIENT_TRANSFORMS[orientation];
};

});



parcelRegister("ioqnC", function(module, exports) {

$parcel$export(module.exports, "LocalFileSource", () => $0acd089032a7a1ea$export$9f61a7e25675739f);
const $0acd089032a7a1ea$export$b52f32369fbb9776 = 10e6; // 10 MB
var $0acd089032a7a1ea$export$9f61a7e25675739f = /*#__PURE__*/ function(LocalFileSource) {
    LocalFileSource["PastedFile"] = "pastedFile";
    LocalFileSource["PastedScreenshot"] = "pastedScreenshot";
    LocalFileSource["LocalUpload"] = "localUpload";
    return LocalFileSource;
}({});

});

parcelRegister("hxXNE", function(module, exports) {

$parcel$export(module.exports, "getPreviewFromBlob", () => $fdfebdfa12ab61e2$export$4fb742eff9613f2d);

var $29M1K = parcelRequire("29M1K");
const $fdfebdfa12ab61e2$export$5412bb65cf4db44f = (dimensions)=>!dimensions.width && !dimensions.height;
async function $fdfebdfa12ab61e2$export$4fb742eff9613f2d(mediaType, file) {
    switch(mediaType){
        case 'image':
        case 'video':
            {
                const dimensions = await (0, $29M1K.getDimensionsFromBlob)(mediaType, file);
                if ($fdfebdfa12ab61e2$export$5412bb65cf4db44f(dimensions)) return {
                    file: file,
                    scaleFactor: 1
                };
                return {
                    file: file,
                    dimensions: dimensions,
                    scaleFactor: 1
                };
            }
        default:
            return {
                file: file
            };
    }
}

});
parcelRegister("29M1K", function(module, exports) {

$parcel$export(module.exports, "getDimensionsFromBlob", () => $c92d9e8096a99b5b$export$71797c284d89a3e1);

var $8IWWt = parcelRequire("8IWWt");

var $5CbXO = parcelRequire("5CbXO");
const $c92d9e8096a99b5b$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $8IWWt.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $5CbXO.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("8IWWt", function(module, exports) {

$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $094f7e5912c5e863$export$a1c3205f28a20414);
const $094f7e5912c5e863$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("5CbXO", function(module, exports) {

$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $3629651e482443d2$export$62aabd5ff85d0451);
const $3629651e482443d2$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("jzW7G", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $08d056d70136c4e2$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("8GKRF")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("8GKRF")).isVideoMimeTypeSupportedByBrowser);

var $92ewp = parcelRequire("92ewp");

var $8GKRF = parcelRequire("8GKRF");

var $lF4MN = parcelRequire("lF4MN");
const $08d056d70136c4e2$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $92ewp.isArchive)(mimeType)) return 'archive';
    if ((0, $8GKRF.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $lF4MN.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $8GKRF.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $lF4MN.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $8GKRF.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $lF4MN.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $8GKRF.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $lF4MN.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("92ewp", function(module, exports) {

$parcel$export(module.exports, "isArchive", () => $addf45fda6198a62$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $addf45fda6198a62$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("8GKRF", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $3af4ecf7d6cb882c$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $3af4ecf7d6cb882c$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $3af4ecf7d6cb882c$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $3af4ecf7d6cb882c$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $3af4ecf7d6cb882c$export$55ca6cdaf6093034 = (mimeType)=>$3af4ecf7d6cb882c$export$74325e3c843a9555(mimeType) || $3af4ecf7d6cb882c$export$c021f2623a75015f(mimeType) || $3af4ecf7d6cb882c$export$ff36075ea755a717(mimeType) || $3af4ecf7d6cb882c$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("lF4MN", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $8b8147e427110cee$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $8b8147e427110cee$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $8b8147e427110cee$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $8b8147e427110cee$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $8b8147e427110cee$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $8b8147e427110cee$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$548d9148a80556a3 = (mimeType)=>$8b8147e427110cee$export$e9a065a80f76311e(mimeType) || $8b8147e427110cee$export$86baad7a89d908e9(mimeType) || $8b8147e427110cee$export$8cba23825d020bbb(mimeType) || $8b8147e427110cee$export$9c2b4de5fdca2ce3(mimeType) || $8b8147e427110cee$export$94e1479e01d2af53(mimeType);

});


parcelRegister("27T0s", function(module, exports) {

$parcel$export(module.exports, "isUndefined", () => $5713248736bc73bb$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $5713248736bc73bb$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $5713248736bc73bb$export$456b25e3a9b4a843);
const $5713248736bc73bb$export$fce6876652108ab = (value)=>value === undefined;
const $5713248736bc73bb$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $5713248736bc73bb$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $5713248736bc73bb$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $5713248736bc73bb$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $5713248736bc73bb$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $5713248736bc73bb$export$456b25e3a9b4a843(byte) {
    let randomHex;
    if (window?.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $5713248736bc73bb$var$getRandomHexValues(byte);
    }
    else randomHex = $5713248736bc73bb$var$getRandomHexValues(byte);
    return randomHex;
}

});


parcelRegister("lSaNN", function(module, exports) {

$parcel$export(module.exports, "getPackageAttributes", () => $6921ec06933aa986$export$12e3140bad86f969);
$parcel$export(module.exports, "getRequestMetadata", () => $6921ec06933aa986$export$989e1becee2b9994);

var $1As4I = parcelRequire("1As4I");
const $6921ec06933aa986$var$packageName = "platform-pkg";
const $6921ec06933aa986$var$packageVersion = "0.0.0-use.local";
function $6921ec06933aa986$export$12e3140bad86f969(componentName) {
    return {
        packageName: $6921ec06933aa986$var$packageName,
        packageVersion: $6921ec06933aa986$var$packageVersion,
        componentName: componentName,
        component: componentName
    };
}
function $6921ec06933aa986$export$989e1becee2b9994(error) {
    if (error && (0, $1As4I.isRequestError)(error)) return error.metadata;
}

});

parcelRegister("9Gobd", function(module, exports) {

$parcel$export(module.exports, "startMediaUploadUfoExperience", () => $d817d17257c4b97f$export$aca2a1278c2ebf9a);
$parcel$export(module.exports, "succeedMediaUploadUfoExperience", () => $d817d17257c4b97f$export$3730e235c28b02d0);
$parcel$export(module.exports, "failMediaUploadUfoExperience", () => $d817d17257c4b97f$export$aa991898181926b9);

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");

var $4TDix = parcelRequire("4TDix");

var $1FyHg = parcelRequire("1FyHg");
const $d817d17257c4b97f$var$packageName = "platform-pkg";
const $d817d17257c4b97f$var$packageVersion = "0.0.0-use.local";
let $d817d17257c4b97f$var$ufoExperience;
const $d817d17257c4b97f$var$initExperience = (id, componentName)=>{
    if (!$d817d17257c4b97f$var$ufoExperience) {
        const inlineExperience = {
            platform: {
                component: `media-picker-${componentName}`
            },
            type: (0, $7Zbvr.ExperienceTypes).Experience,
            performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult,
            featureFlags: (0, $4TDix.getFeatureFlagKeysAllProducts)()
        };
        $d817d17257c4b97f$var$ufoExperience = new (0, $cBycP.ConcurrentExperience)('media-upload', inlineExperience);
    }
    return $d817d17257c4b97f$var$ufoExperience.getInstance(id);
};
const $d817d17257c4b97f$var$getExperience = (id)=>{
    if ($d817d17257c4b97f$var$ufoExperience) return $d817d17257c4b97f$var$ufoExperience.getInstance(id);
};
const $d817d17257c4b97f$export$aca2a1278c2ebf9a = (id, componentName)=>{
    $d817d17257c4b97f$var$initExperience(id, componentName).start();
};
const $d817d17257c4b97f$export$3730e235c28b02d0 = (id, properties)=>{
    $d817d17257c4b97f$var$getExperience(id)?.success({
        metadata: {
            fileAttributes: properties,
            packageName: $d817d17257c4b97f$var$packageName,
            packageVersion: $d817d17257c4b97f$var$packageVersion,
            mediaEnvironment: (0, $1FyHg.getMediaEnvironment)(),
            mediaRegion: (0, $1FyHg.getMediaRegion)()
        }
    });
};
const $d817d17257c4b97f$export$aa991898181926b9 = (id, properties)=>{
    const refinedMetadata = {
        ...properties,
        packageName: $d817d17257c4b97f$var$packageName,
        packageVersion: $d817d17257c4b97f$var$packageVersion,
        mediaEnvironment: (0, $1FyHg.getMediaEnvironment)(),
        mediaRegion: (0, $1FyHg.getMediaRegion)()
    };
    $d817d17257c4b97f$var$getExperience(id)?.failure({
        metadata: refinedMetadata
    });
};

});
parcelRegister("cBycP", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac);

var $dCAsn = parcelRequire("dCAsn");

var $boHLC = parcelRequire("boHLC");
class $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $boHLC.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $dCAsn.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});

parcelRegister("4TDix", function(module, exports) {

$parcel$export(module.exports, "getFeatureFlagKeysAllProducts", () => $da8fe37d22416a40$export$c8bcd5e6111ea1f3);
$parcel$export(module.exports, "getMediaFeatureFlag", () => $da8fe37d22416a40$export$383e8f51978266d);

var $2zWou = parcelRequire("2zWou");

var $66Zz4 = parcelRequire("66Zz4");

var $aU0XH = parcelRequire("aU0XH");
const $da8fe37d22416a40$export$b79c645ae6a0e5c7 = (flags)=>{
    const pairs = Object.entries(flags);
    return pairs.filter(([_key, value])=>!!value).map(([key])=>key);
};
const $da8fe37d22416a40$export$c8bcd5e6111ea1f3 = ()=>{
    const productKeys = (0, $66Zz4.getProductKeys)();
    let ldFeatureFlags = [];
    (0, $2zWou.supportedProducts).forEach((product)=>{
        ldFeatureFlags = [
            ...ldFeatureFlags,
            ...Object.values(productKeys[product])
        ];
    });
    return ldFeatureFlags.filter((flag)=>flag !== '');
};
const $da8fe37d22416a40$export$836625761e76d373 = {
    mediaInline: false
};
function $da8fe37d22416a40$export$383e8f51978266d(flagName, featureFlags) {
    return (0, $aU0XH.getGenericFeatureFlag)(flagName, $da8fe37d22416a40$export$836625761e76d373, featureFlags);
}

});
parcelRegister("2zWou", function(module, exports) {

$parcel$export(module.exports, "supportedProducts", () => $52beebacaaaff308$export$2db74afa1ef496f1);
// Media feature flags - type and defaults defined here in one source of truth
const $52beebacaaaff308$export$2db74afa1ef496f1 = [
    'confluence',
    'jira'
];

});

parcelRegister("66Zz4", function(module, exports) {

$parcel$export(module.exports, "getProductKeys", () => $7ad87e8114af2f32$export$189fe120be7e73fc);
const $7ad87e8114af2f32$var$productKeys = {
    confluence: {
        mediaInline: ''
    },
    jira: {
        // Manged by Linking Platform. No Rollout plan found for Jira
        mediaInline: ''
    }
};
const $7ad87e8114af2f32$export$189fe120be7e73fc = ()=>$7ad87e8114af2f32$var$productKeys;

});

parcelRegister("aU0XH", function(module, exports) {

$parcel$export(module.exports, "getGenericFeatureFlag", () => $04a8c3e5f240e16a$export$f2687d0de19e4973);

var $25hNX = parcelRequire("25hNX");
function $04a8c3e5f240e16a$export$f2687d0de19e4973(flagName, defaults, featureFlags) {
    const devOverride = (0, $25hNX.getLocalMediaFeatureFlag)(flagName);
    if (devOverride !== null) try {
        return JSON.parse(devOverride);
    } catch (e) {}
    if (featureFlags) return flagName in featureFlags ? featureFlags[flagName] : defaults[flagName];
    return defaults[flagName];
}

});
parcelRegister("25hNX", function(module, exports) {

$parcel$export(module.exports, "getLocalMediaFeatureFlag", () => $231bde62bcb02f83$export$d125817a2695dbc9);
// window.localStorage is easier to mock in tests if wrapped in this module
const $231bde62bcb02f83$export$d125817a2695dbc9 = (key)=>{
    try {
        return typeof window !== 'undefined' && window.localStorage ? window.localStorage.getItem(key) : null;
    } catch (e) {
    // do nothing, return null by default
    }
    return null;
};

});



parcelRegister("1FyHg", function(module, exports) {

$parcel$export(module.exports, "MediaStore", () => $5d0b8a2b8f8558c8$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $5d0b8a2b8f8558c8$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $5d0b8a2b8f8558c8$export$20f9315304dd6726);
parcelRequire("LmkUS");
var $gPrGh = parcelRequire("gPrGh");
var $hQvj4 = parcelRequire("hQvj4");

var $7E56q = parcelRequire("7E56q");

var $7LFAu = parcelRequire("7LFAu");

var $1As4I = parcelRequire("1As4I");
var $hzvnk = parcelRequire("hzvnk");

var $ale1y = parcelRequire("ale1y");

var $eeVEv = parcelRequire("eeVEv");

var $5cMkQ = parcelRequire("5cMkQ");

var $VSDnB = parcelRequire("VSDnB");

var $h2NC7 = parcelRequire("h2NC7");
const $5d0b8a2b8f8558c8$var$MEDIA_API_REGION = 'media-api-region';
const $5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $5d0b8a2b8f8558c8$var$extendImageParams = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': params?.['max-age'] ?? (0, $7E56q.FILE_CACHE_MAX_AGE),
        allowAnimated: params?.allowAnimated ?? true,
        mode: params?.mode ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $7E56q.MAX_RESOLUTION),
            height: (0, $7E56q.MAX_RESOLUTION)
        } : {}
    };
};
const $5d0b8a2b8f8558c8$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
const $5d0b8a2b8f8558c8$var$cdnFeatureFlag = (endpoint)=>{
    let result = endpoint;
    if ((0, $VSDnB.fg)('platform_media_cdn_delivery')) {
        if ((0, $h2NC7.isCommercial)()) result += '/cdn';
    }
    return result;
};
class $5d0b8a2b8f8558c8$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.resolveAuth = (authContext)=>(0, $5cMkQ.resolveAuth)(this.config.authProvider, authContext, this.config.authProviderTimeout);
        this.resolveInitialAuth = ()=>(0, $5cMkQ.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $gPrGh.ChunkHashAlgorithm).Sha1;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const options = {
            params: $5d0b8a2b8f8558c8$var$extendImageParams(params),
            auth: auth
        };
        const imageEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('image');
        return (0, $eeVEv.mapToMediaCdnUrl)((0, $ale1y.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
    }
    async getFileBinary(id, collectionName, abortController, maxAge = (0, $7E56q.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('binary');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, abortController, true).then((0, $ale1y.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $7E56q.FILE_CACHE_MAX_AGE)) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const binaryEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('binary');
        return (0, $eeVEv.mapToMediaCdnUrl)((0, $ale1y.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
    }
    async getArtifactURL(artifacts, artifactName, collectionName) {
        const artifactUrl = (0, $7LFAu.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': (0, $7E56q.FILE_CACHE_MAX_AGE)
            },
            auth: auth
        };
        return (0, $ale1y.createUrl)((0, $eeVEv.mapToMediaCdnUrl)(artifactUrl, auth.token), options);
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('image');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: $5d0b8a2b8f8558c8$var$extendImageParams(params, fetchMaxRes),
            headers: headers,
            traceContext: traceContext,
            addMediaClientParam: true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $ale1y.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext, includeHashForDuplicateFiles) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors,
                includeHashForDuplicateFiles: includeHashForDuplicateFiles
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, options);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    copyFile(id, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/v2/file/copy'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify({
                id: id
            }),
            traceContext: traceContext,
            clientOptions: {
                retryOptions: {
                    shouldRetryError: (err)=>(0, $ale1y.defaultShouldRetryError)(err) || (0, $1As4I.isRequestError)(err) && err?.metadata?.statusCode === 401
                }
            }
        };
        return this.request('/v2/file/copy', options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async registerCopyIntents(files, traceContext, resolvedAuth) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/intents'
        };
        const options = {
            ...metadata,
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify({
                files: files
            }),
            traceContext: traceContext,
            resolvedAuth: resolvedAuth
        };
        await this.request('/file/copy/intents', options);
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam, resolvedAuth: resolvedAuth } = options;
        const auth = resolvedAuth ?? await this.resolveAuth(authContext);
        const clientId = (0, $hQvj4.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = (0, $ale1y.extendTraceContext)(traceContext);
        const extendedParams = addMediaClientParam ? {
            ...params,
            clientId: clientId
        } : params;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $eeVEv.mapToMediaCdnUrl)(url, auth.token);
        const response = await (0, $hzvnk.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: extendedParams,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    async testUrl(url, options = {}) {
        const { traceContext: traceContext } = options;
        await (0, $hzvnk.request)(url, {
            method: 'HEAD',
            traceContext: (0, $ale1y.extendTraceContext)(traceContext),
            clientOptions: {
                retryOptions: {
                    maxAttempts: 1
                }
            }
        });
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}
const $5d0b8a2b8f8558c8$var$getValueFromSessionStorage = (key)=>{
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage = (key, value)=>{
    if (!value || !(window && window.sessionStorage)) return;
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
const $5d0b8a2b8f8558c8$export$c8b741e18397852a = ()=>{
    return $5d0b8a2b8f8558c8$var$getValueFromSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT);
};
const $5d0b8a2b8f8558c8$export$20f9315304dd6726 = ()=>{
    return $5d0b8a2b8f8558c8$var$getValueFromSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_REGION);
};

});
parcelRegister("7LFAu", function(module, exports) {

$parcel$export(module.exports, "getArtifactUrl", () => $cc56e843db2c0cea$export$1cc24defa44e7f84);

var $VSDnB = parcelRequire("VSDnB");

var $h2NC7 = parcelRequire("h2NC7");
const $cc56e843db2c0cea$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $h2NC7.isCommercial)() && (0, $VSDnB.fg)('platform_media_cdn_delivery') && artifacts[prop]?.url) return `${artifacts[prop]?.url}/cdn`;
    return artifacts[prop]?.url;
};

});
parcelRegister("h2NC7", function(module, exports) {

$parcel$export(module.exports, "isCommercial", () => $bc3c8a168b66c7db$export$df69ff6733e73e50);
function $bc3c8a168b66c7db$export$df69ff6733e73e50() {
    const global = globalThis;
    const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (perimeter) // Note: reference to MICROS_PERIMETER can be found in: https://hello.atlassian.net/wiki/spaces/MICROS/pages/167212650/Runtime+configuration+environment+variables+and+adding+secrets#Micros-provided-variables
    return perimeter === 'commercial';
    // Return true if the current hostname does NOT match any of the forbidden patterns.
    return !global.location?.hostname?.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/);
}

});


parcelRegister("hzvnk", function(module, exports) {

$parcel$export(module.exports, "request", () => $ac16e0b7f5d65450$export$b5fe3f66a567bec0);

var $1As4I = parcelRequire("1As4I");

var $ale1y = parcelRequire("ale1y");
async function $ac16e0b7f5d65450$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $ale1y.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $ale1y.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $ale1y.createProcessFetchResponse)(metadata));
    return (0, $ale1y.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("ale1y", function(module, exports) {

$parcel$export(module.exports, "extendTraceContext", () => $96f7b73b7943f312$export$ee24a95986dfd173);
$parcel$export(module.exports, "createUrl", () => $96f7b73b7943f312$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $96f7b73b7943f312$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $96f7b73b7943f312$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $96f7b73b7943f312$export$5cc7b0795397da86);
$parcel$export(module.exports, "defaultShouldRetryError", () => $96f7b73b7943f312$export$fee2242cbb339663);
$parcel$export(module.exports, "fetchRetry", () => $96f7b73b7943f312$export$782df2acbe10b22c);
$parcel$export(module.exports, "createRequestErrorReason", () => $96f7b73b7943f312$export$6397609af718d008);
$parcel$export(module.exports, "createProcessFetchResponse", () => $96f7b73b7943f312$export$6e2e477edb7d6032);
parcelRequire("LmkUS");
var $hQvj4 = parcelRequire("hQvj4");

var $27T0s = parcelRequire("27T0s");

var $3JV6R = parcelRequire("3JV6R");

var $1As4I = parcelRequire("1As4I");
const $96f7b73b7943f312$var$getStatusCode = (error)=>(0, $1As4I.isRequestError)(error) && error.metadata?.statusCode && error.metadata.statusCode;
function $96f7b73b7943f312$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $96f7b73b7943f312$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $96f7b73b7943f312$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $96f7b73b7943f312$export$bc96a6a479480590(error) {
    const statusCode = error && $96f7b73b7943f312$var$getStatusCode(error);
    return statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $96f7b73b7943f312$export$ee24a95986dfd173 = (traceContext)=>traceContext ? {
        ...traceContext,
        spanId: traceContext?.spanId || (0, $27T0s.getRandomHex)(8)
    } : undefined;
const $96f7b73b7943f312$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $96f7b73b7943f312$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$96f7b73b7943f312$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$96f7b73b7943f312$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $96f7b73b7943f312$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $hQvj4.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $96f7b73b7943f312$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth?.baseUrl);
    const authParams = auth && (0, $3JV6R.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.append(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $96f7b73b7943f312$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...$96f7b73b7943f312$export$eaf4479116d2f925(auth),
        ...$96f7b73b7943f312$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $96f7b73b7943f312$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $1As4I.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$96f7b73b7943f312$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $96f7b73b7943f312$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $1As4I.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$96f7b73b7943f312$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $96f7b73b7943f312$export$fee2242cbb339663 = (err)=>{
    const statusCode = $96f7b73b7943f312$var$getStatusCode(err);
    return $96f7b73b7943f312$export$ad8c5cf7dd4c3caf(err) || (statusCode ? statusCode >= 500 : false);
};
const $96f7b73b7943f312$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    maxAttempts: 5,
    factor: 2
};
function $96f7b73b7943f312$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $1As4I.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $96f7b73b7943f312$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$96f7b73b7943f312$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor, shouldRetryError: shouldRetryError = $96f7b73b7943f312$export$fee2242cbb339663 } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $96f7b73b7943f312$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($96f7b73b7943f312$export$de0b576cf7ce4a53(err)) throw new (0, $1As4I.RequestError)('clientAbortedRequest', metadata, err);
        if (!shouldRetryError(err)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $1As4I.isRequestError)(lastError)) throw $96f7b73b7943f312$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $1As4I.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $96f7b73b7943f312$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $96f7b73b7943f312$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $96f7b73b7943f312$export$6397609af718d008(statusCode);
    return new (0, $1As4I.RequestError)(reason, {
        ...metadata,
        ...$96f7b73b7943f312$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $96f7b73b7943f312$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $96f7b73b7943f312$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $96f7b73b7943f312$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("3JV6R", function(module, exports) {

$parcel$export(module.exports, "mapAuthToQueryParameters", () => $30be3f63a223d0a0$export$6833b130611df767);
parcelRequire("LmkUS");
var $hQvj4 = parcelRequire("hQvj4");
function $30be3f63a223d0a0$export$6833b130611df767(auth) {
    if ((0, $hQvj4.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});



parcelRegister("eeVEv", function(module, exports) {

$parcel$export(module.exports, "mapToMediaCdnUrl", () => $ac061c5da59ee1d7$export$fb88a576cf28364d);

var $VSDnB = parcelRequire("VSDnB");

var $h2NC7 = parcelRequire("h2NC7");
const $ac061c5da59ee1d7$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
// Cloudfront has a hard limit of 8,192 bytes
// https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/cloudfront-limits.html
// Assuming other parts of the URL make up a max of ~1000 (in reality it's lower), the token can be ~7000
const $ac061c5da59ee1d7$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
function $ac061c5da59ee1d7$export$fb88a576cf28364d(url, token) {
    const tokenLength = token?.length ?? 0;
    if (!(0, $h2NC7.isCommercial)() || tokenLength > $ac061c5da59ee1d7$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $VSDnB.fg)('platform_media_cdn_delivery') && (0, $VSDnB.fg)('platform_media_cdn_single_host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = $ac061c5da59ee1d7$export$8a9b6ab3569a543a[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});

parcelRegister("5cMkQ", function(module, exports) {

$parcel$export(module.exports, "resolveAuth", () => $c6441b149d7d138c$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $c6441b149d7d138c$export$5211e1371264aec3);

var $ciNTb = parcelRequire("ciNTb");

var $irn0C = parcelRequire("irn0C");
const $c6441b149d7d138c$export$560085fe411c0660 = 10000;
const $c6441b149d7d138c$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $c6441b149d7d138c$export$560085fe411c0660)=>{
    let auth;
    try {
        auth = await Promise.race([
            authProvider(authContext),
            (0, $irn0C.rejectTimeout)(authProviderTimeout, new (0, $ciNTb.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        if (err instanceof (0, $ciNTb.MediaStoreError)) throw err;
        throw new (0, $ciNTb.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $ciNTb.MediaStoreError)('emptyAuth');
    /*
    We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
    Token expiration check in the frontend is a bad idea. Don't do it!
    More info:
    https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
    https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
  */ return auth;
};
const $c6441b149d7d138c$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $ciNTb.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("ciNTb", function(module, exports) {

$parcel$export(module.exports, "MediaStoreError", () => $63300db0f534a20c$export$b78480bd311630bc);

var $gFZHi = parcelRequire("gFZHi");
class $63300db0f534a20c$export$b78480bd311630bc extends (0, $gFZHi.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason, undefined, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}
function $63300db0f534a20c$export$8d2a9b675b2ce37a(err) {
    return err instanceof $63300db0f534a20c$export$b78480bd311630bc;
}

});

parcelRegister("irn0C", function(module, exports) {

$parcel$export(module.exports, "rejectTimeout", () => $974e005d07aa0732$export$cf2d2a1124beacb2);
const $974e005d07aa0732$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $974e005d07aa0732$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});





parcelRegister("asGq3", function(module, exports) {

$parcel$export(module.exports, "default", () => $54b73f8a470ff958$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fWXJB = parcelRequire("fWXJB");
var $6ARj7 = parcelRequire("6ARj7");

var $kxFlx = parcelRequire("kxFlx");


var $dtHsj = parcelRequire("dtHsj");

var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");
const $54b73f8a470ff958$var$defaultOptions = {
    style: 'unit',
    unitDisplay: 'short',
    minimumFractionDigits: 2
};
const $54b73f8a470ff958$var$fileSizeFormatters = {
    kilobyte: new Intl.NumberFormat('en', {
        ...$54b73f8a470ff958$var$defaultOptions,
        unit: 'kilobyte'
    }),
    megabyte: new Intl.NumberFormat('en', {
        ...$54b73f8a470ff958$var$defaultOptions,
        unit: 'megabyte'
    }),
    gigabyte: new Intl.NumberFormat('en', {
        ...$54b73f8a470ff958$var$defaultOptions,
        unit: 'gigabyte'
    })
};
const $54b73f8a470ff958$var$formatFileSize = (size)=>{
    let formattedSize;
    if (size < 1000000) {
        formattedSize = size / 1000;
        return $54b73f8a470ff958$var$fileSizeFormatters.kilobyte.format(formattedSize);
    } else if (size >= 1000000 && size < 1000000000) {
        formattedSize = size / 1000000;
        return $54b73f8a470ff958$var$fileSizeFormatters.megabyte.format(formattedSize);
    } else {
        formattedSize = size / 1000000000;
        return $54b73f8a470ff958$var$fileSizeFormatters.gigabyte.format(formattedSize);
    }
};
const $54b73f8a470ff958$var$FlagGroupContent = ({ flagData: flagData, onFlagDismissed: onFlagDismissed })=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ARj7.default), {
        onDismissed: onFlagDismissed,
        children: flagData.map((data, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $fWXJB.default), {
                id: i,
                icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kxFlx))), {
                    color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
                    label: "Fail",
                    LEGACY_size: "medium",
                    spacing: "spacious"
                }),
                title: intl.formatMessage((0, $dtHsj.errorFlagMessages).errorTitle),
                description: data.reason === 'fileEmpty' ? intl.formatMessage((0, $dtHsj.errorFlagMessages).fileEmptyDescription, {
                    fileName: data.fileName
                }) : intl.formatMessage((0, $dtHsj.errorFlagMessages).uploadRejectionDescription, {
                    fileName: data.fileName,
                    limit: $54b73f8a470ff958$var$formatFileSize(data.limit)
                })
            }, i))
    });
};
const $54b73f8a470ff958$var$ErrorFlagGroup = ({ flagData: flagData, onFlagDismissed: onFlagDismissed, intl: intl })=>{
    return intl ? /*#__PURE__*/ (0, $2OMIu.jsx)($54b73f8a470ff958$var$FlagGroupContent, {
        flagData: flagData,
        onFlagDismissed: onFlagDismissed
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: "en",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($54b73f8a470ff958$var$FlagGroupContent, {
            flagData: flagData,
            onFlagDismissed: onFlagDismissed
        })
    });
};
var $54b73f8a470ff958$export$2e2bcd8739ae039 = (0, $8RXs9.default)($54b73f8a470ff958$var$ErrorFlagGroup, {
    enforceContext: false
});

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("dtHsj", function(module, exports) {

$parcel$export(module.exports, "errorFlagMessages", () => $a2555e4336ccbb7a$export$889413494ace092f);

var $7VHMR = parcelRequire("7VHMR");
const $a2555e4336ccbb7a$export$889413494ace092f = (0, $7VHMR.defineMessages)({
    errorTitle: {
        id: 'fabric.media.errorFlagTitle',
        defaultMessage: 'Your file failed to upload',
        description: 'a title for a flag that describes that a file failed to upload'
    },
    uploadRejectionDescription: {
        id: 'fabric.media.uploadRejectionFlagDescription',
        defaultMessage: '{fileName} is too big to upload. Files must be less than {limit}.',
        description: 'a description for a flag detailing that a file was too large to upload'
    },
    fileEmptyDescription: {
        id: 'fabric.media.fileEmptyFlagDescription',
        defaultMessage: 'The file you selected was empty. Please select another file and try again.',
        description: 'a description for a flag detailing that a file was zero bytes'
    }
});

});




//# sourceMappingURL=@atlaskit-internal_media-dropzone.fdd3e60a.js.map
